import { VNode, reactive } from 'vue';
import type { Unary } from '@vaaas/fpts/data';
import state from '.';

export type BooleanDialogProps = {
    title: string;
    body: string | VNode;
    ok: string;
    cancel: string;
}

export const boolean_dialog_defaults: BooleanDialogProps & { promise: Unary<boolean, void> } = {
    title: '',
    body: '',
    ok: 'Okay',
    cancel: 'Cancel',
    promise: () => undefined,
};

export const boolean_dialog_props = reactive({ ...boolean_dialog_defaults });

export function show_boolean_dialog({
    title,
    body,
    ok = 'Okay',
    cancel = 'Cancel',
}: BooleanDialogProps): Promise<boolean> {
    return new Promise(done => {
        state.modal.booleanDialog = true;
        boolean_dialog_props.title = title;
        boolean_dialog_props.body = body;
        boolean_dialog_props.ok = ok;
        boolean_dialog_props.cancel = cancel;
        boolean_dialog_props.promise = done;
    });
}

export const troubleshooting_messages = reactive([] as string[]);

export function show_import_troubleshooting_modal(incoming: Array<string>) {
    troubleshooting_messages.push(...incoming);
    state.modal.importTroubleshootingModal = true;
}

type ReadValueType =
    'ringx'
    | 'ringy'
    | 'ringz'
    | 'rodx'
    | 'rody'
    | 'rodz'
    | 'tube'

export const read_value_props = reactive({
    type: undefined as ReadValueType | undefined,
    value: 0,
});

export function display_read_value_modal(valuetype: ReadValueType, initial = 0) {
    read_value_props.type = valuetype;
    read_value_props.value = initial;
    state.modal.readValueModal = true;
}
